// Page components
import AboutSection from "../components/AboutSection";
import ScrollTop from "../components/ScrollTop";
// Animations
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
// Scroll at the Top of the window

const Aboutus = () => {
  return (
    <motion.div
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <AboutSection />
      <ScrollTop />
    </motion.div>
  );
};

export default Aboutus;
